import { Button, Modal, Row } from 'antd'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import React from 'react'

function FinanceBreakDown(props) {
  const { doc } = props
  const { visible, onShow, onCancel } = useModalShow()

  return (
    <>
      <Modal
        visible={visible}
        title={'Documents'}
        onCancel={onCancel}
        destroyOnClose={true}
        width={'75%'}>
        <Row />
      </Modal>
      <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
        Break Down
      </Button>
    </>
  )
}

export default FinanceBreakDown
